module.exports = __webpack_public_path__ + "img/documents.f27a75ef.svg";